import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    container: {
        boxShadow: '0px 0px 7px rgba(0, 0, 0, 0.25)',
        margin: '10px 0',
        height: '100px',
    },
    rootGridImage: {
        width: '185px',
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            width: '150px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '120px',
        },
    },
    wrapperImage: {
        // padding: '5px',
        width: '100%',
        height: '100%',
        '& img': {
            width: '100%',
            objectFit: 'cover',
            // borderRadius: '5px',
            height: '100%',
        },
    },
    rootGridContent: {
        display: 'flow-root',
        padding: '10px 20px',
        width: 'calc(100% - 185px)',
        '& div': {
            width: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            width: 'calc(100% - 150px)',
        },
        [theme.breakpoints.down('xs')]: {
            width: 'calc(100% - 120px)',
        },
    },
    textTitle: {
        fontSize: themeCommon.fontSize14px,
        fontFamily: themeCommon.RobotoBold,
        color: '#000000',
        cursor: 'pointer',
    },
    textDescription: {
        fontSize: themeCommon.fontSize12px,
        color: '#2F2F2F',
    },
    textEllipsisTitle: {
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    textEllipsisDes: {
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitLineClamp: '2',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
    },
    wrapperUpdatedDate: {
        marginTop: '10px',
    },
}), {
    name: 'NewsHolderHead',
    index: 1,
})
// drop-shadow(0px 0px 7px rgba(0, 0, 0, 0.25));
export default useStyles;